<template>
  <div class="social-media-links" :class="{ desktop: $isDesktop }">
    <a href="https://www.facebook.com/pitchup">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        stroke-linejoin="round"
        stroke-miterlimit="1.41421"
        clip-rule="evenodd"
        viewBox="0 0 34 34"
      >
        <path
          fill="#3b5997"
          d="M16.686 0c9.215 0 16.686 7.471 16.686 16.686s-7.471 16.686-16.686 16.686S0 25.901 0 16.686 7.471 0 16.686 0z"
        />
        <path
          fill="#fff"
          d="M20.551 7.221v2.757s-2.028-.203-2.536.576c-.278.426-.113 1.672-.138 2.567h2.691c-.228 1.046-.391 1.755-.558 2.661h-2.148v8.564h-3.727c.001-2.64-.001-5.72 0-8.53h-1.586v-2.695h1.569c.08-1.97.11-3.922 1.087-4.916 1.099-1.118 2.146-.984 5.346-.984z"
        />
      </svg>
    </a>
    <a href="https://twitter.com/pitchup">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        stroke-linejoin="round"
        stroke-miterlimit="1.41421"
        clip-rule="evenodd"
        viewBox="0 0 34 34"
      >
        <path
          fill="#00abef"
          d="M16.686 0c9.215 0 16.686 7.471 16.686 16.686s-7.471 16.686-16.686 16.686S0 25.901 0 16.686 7.471 0 16.686 0z"
        />
        <path
          fill="#fff"
          d="M27.024 10.003c-.094.743-1.172 1.488-1.825 2.053.645 9.496-10.123 15.419-17.946 10.608 2.194.016 4.665-.586 5.97-1.825-1.898-.308-3.242-1.168-3.764-2.852.556-.052 1.336.12 1.711-.114-1.736-.659-3.109-1.682-3.194-3.992.619.066.94.429 1.711.342-1.122-.72-2.404-3.456-1.254-5.475 2.037 2.259 4.58 4.012 8.554 4.335-.986-4.193 4.572-6.791 7.072-3.764.972-.207 1.791-.567 2.623-.913-.341.952-1.033 1.552-1.711 2.167.737-.137 1.516-.233 2.053-.57z"
        />
      </svg>
    </a>
    <a href="https://instagram.com/pitchupcom">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        stroke-linejoin="round"
        stroke-miterlimit="1.41421"
        clip-rule="evenodd"
        viewBox="0 0 34 34"
      >
        <path
          fill="#d93175"
          d="M16.686 0c9.216 0 16.686 7.471 16.686 16.686s-7.47 16.686-16.686 16.686C7.471 33.372 0 25.901 0 16.686S7.471 0 16.686 0z"
        />
        <path
          fill="#fff"
          fill-rule="nonzero"
          d="M16.686 6.488c-2.77 0-3.117.011-4.205.061-1.085.049-1.827.222-2.475.474-.671.261-1.24.609-1.807 1.176s-.915 1.136-1.176 1.807c-.252.648-.425 1.39-.474 2.475-.05 1.088-.061 1.435-.061 4.205s.011 3.117.061 4.205c.049 1.085.222 1.827.474 2.475.261.671.609 1.24 1.176 1.807s1.136.916 1.807 1.176c.648.252 1.39.425 2.475.474 1.088.05 1.435.062 4.205.062s3.117-.012 4.205-.062c1.085-.049 1.827-.222 2.475-.474.671-.26 1.24-.609 1.807-1.176s.916-1.136 1.176-1.807c.252-.648.425-1.39.474-2.475.05-1.088.062-1.435.062-4.205s-.012-3.117-.062-4.205c-.049-1.085-.222-1.827-.474-2.475-.26-.671-.609-1.24-1.176-1.807s-1.136-.915-1.807-1.176c-.648-.252-1.39-.425-2.475-.474-1.088-.05-1.435-.061-4.205-.061zm0 1.837c2.723 0 3.046.01 4.121.06.994.045 1.534.211 1.894.351.476.185.816.406 1.172.763.357.356.578.696.763 1.172.14.36.306.9.352 1.894.049 1.075.059 1.398.059 4.121 0 2.723-.01 3.046-.059 4.121-.046.994-.212 1.534-.352 1.894-.185.476-.406.816-.763 1.172-.356.357-.696.578-1.172.763-.36.14-.9.306-1.894.352-1.075.049-1.398.059-4.121.059-2.723 0-3.046-.01-4.121-.059-.994-.046-1.534-.212-1.894-.352-.476-.185-.816-.406-1.172-.763-.357-.356-.578-.696-.763-1.172-.14-.36-.306-.9-.351-1.894-.05-1.075-.06-1.398-.06-4.121 0-2.723.01-3.046.06-4.121.045-.994.211-1.534.351-1.894.185-.476.406-.816.763-1.172.356-.357.696-.578 1.172-.763.36-.14.9-.306 1.894-.351 1.075-.05 1.398-.06 4.121-.06z"
        />
        <path
          fill="#fff"
          fill-rule="nonzero"
          d="M16.686 20.086c-1.877 0-3.399-1.522-3.399-3.4 0-1.877 1.522-3.399 3.399-3.399 1.878 0 3.4 1.522 3.4 3.399 0 1.878-1.522 3.4-3.4 3.4zm0-8.637c-2.892 0-5.237 2.345-5.237 5.237s2.345 5.237 5.237 5.237 5.237-2.345 5.237-5.237-2.345-5.237-5.237-5.237zm6.668-.207c0 .676-.548 1.224-1.224 1.224-.676 0-1.224-.548-1.224-1.224 0-.676.548-1.224 1.224-1.224.676 0 1.224.548 1.224 1.224z"
        />
      </svg>
    </a>
    <a href="https://www.linkedin.com/company/pitchup-com">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        stroke-linejoin="round"
        stroke-miterlimit="1.41421"
        clip-rule="evenodd"
        viewBox="0 0 34 34"
      >
        <path
          fill="#017fb1"
          d="M16.686 0c9.215 0 16.686 7.471 16.686 16.686s-7.471 16.686-16.686 16.686S0 25.901 0 16.686 7.471 0 16.686 0z"
        />
        <path
          fill="#fff"
          d="M10.345 6.867c1.122-.014 1.731.557 2.077 1.329.192.429.244 1.121.042 1.599-.295.697-.858 1.135-1.662 1.329-.349.084-.849-.044-1.059-.125-.9-.345-1.779-1.439-1.287-2.741.209-.555.681-1.024 1.225-1.246.152-.041.305-.083.457-.125.075-.017.157.01.207-.02zm12.087 17.735v-5.026c0-1.099.055-2.224-.333-2.97-.194-.374-.452-.644-.851-.81-.137-.056-.256-.026-.415-.062-.109-.024-.299-.071-.436-.041-.195.042-.416.026-.603.083-.512.156-.903.464-1.142.893-.351.631-.353 1.579-.353 2.554v3.593c0 .551.076 1.283-.021 1.786h-3.655V12.764h3.531v1.62h.041c.491-.849 1.214-1.389 2.202-1.744.895-.322 2.557-.176 3.322.145.307.129.582.315.831.499.165.122.356.252.478.415.341.458.59.97.789 1.578.088.271.091.607.145.852.154.701.145 1.558.145 2.409v4.942c0 .36.042.799-.02 1.122h-3.655zM8.643 12.764h3.655v11.837H8.643z"
        />
      </svg>
    </a>
    <a href="https://www.pinterest.com/pitchup/">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        stroke-linejoin="round"
        stroke-miterlimit="1.41421"
        clip-rule="evenodd"
        viewBox="0 0 34 34"
      >
        <path
          fill="#cb1f27"
          d="M16.686 0c9.215 0 16.686 7.471 16.686 16.686s-7.471 16.686-16.686 16.686S0 25.901 0 16.686 7.471 0 16.686 0z"
        />
        <path
          fill="#fff"
          d="M15.48 19.542c-.133.521-.266 1.068-.405 1.602-.137.526-.257 1.06-.456 1.544-.33.802-.748 1.576-1.298 2.203-.365.417-.287.25-.397.228-.084-.017-.091-.098-.107-.215-.09-.638-.029-1.374.004-2.089.038-.816.212-1.494.374-2.172.308-1.29.601-2.555.911-3.855.021-.086.077-.229.057-.278-.14-.361-.232-.685-.272-1.064-.046-.435-.011-.841.089-1.215.175-.662.579-1.248 1.202-1.462.397-.136.836-.075 1.102.082.275.161.463.417.551.779.093.385.024.845-.051 1.183-.17.762-.392 1.335-.595 2.07-.1.365-.214.74-.12 1.134.086.361.277.61.538.797.27.194.59.3 1.032.285.779-.027 1.321-.518 1.684-.981.579-.741.93-1.741 1.063-2.931.043-.384.074-.825.044-1.26-.055-.803-.31-1.449-.715-1.95-.385-.476-.931-.856-1.595-1.07-.659-.211-1.571-.282-2.38-.145-1.472.248-2.51 1.072-3.121 2.209-.321.596-.532 1.281-.532 2.133 0 .658.165 1.167.431 1.564.084.126.208.23.291.374.117.203-.018.507-.076.728-.07.266-.078.633-.393.639-.13.003-.294-.092-.405-.152-.828-.451-1.332-1.272-1.538-2.336-.126-.646-.125-1.401 0-2.026.121-.604.346-1.161.595-1.614.517-.94 1.274-1.691 2.197-2.228.708-.413 1.508-.702 2.481-.842.323-.046.657-.065 1.019-.082 1.059-.05 2.023.187 2.747.506.766.337 1.376.786 1.893 1.342.532.572.919 1.239 1.165 2.07.128.433.252.896.252 1.431 0 .536-.115 1.009-.195 1.481-.301 1.769-1.155 3.216-2.437 4.039-.311.2-.687.384-1.114.506-.424.122-.907.213-1.425.177-.502-.034-.913-.168-1.259-.36-.343-.191-.632-.425-.836-.779z"
        />
      </svg>
    </a>
  </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class AppMenuSocialLinks extends Vue {}

export default toNative(AppMenuSocialLinks)
</script>

<style scoped>
.social-media-links {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 3em 1.4em 2em 1.8em;
}

.social-media-links a {
  display: block;
  width: 10vw;
  height: auto;
  min-width: 2em;
  max-width: 4em;
}

.social-media-links a:active {
  filter: brightness(60%);
}

/* desktop & tablet */
.social-media-links.desktop {
  gap: 2vw;
  margin: 0;
  justify-content: flex-start;
}
</style>
